import * as React from 'react';
import ResizeHandle from './ResizeHandle';

interface ResizeControlsProps {
    width: number;
    height: number;
    top: number;
    left: number;
    position: string;
    zIndex: number;
    resizeControls: string[];
    pointerEventsNone?: boolean;
    dataTestId?: string;
    outline?: number;
    onResize(dx: number, dy: number, pos: string): void;
    onDragStart?(): void;
    onDragEnd?(): void;
}

interface ResizeControlsState {
    dragging: boolean;
}

export default class ResizeControls extends React.Component<ResizeControlsProps, ResizeControlsState> {
    static defaultProps = {
        pointerEventsNone: true,
        outline: 0
    };
    private root: HTMLElement;

    constructor() {
        super();
        this.state = {dragging: false};
    }

    componentDidMount() {
        this.root.style.opacity = "";
    }

    render() {
        const d = this.props.outline / 2;
        const smallWidth = this.props.width < 70;
        const smallHeight = this.props.height < 70;
        const controls = this.props.resizeControls;
        const handlers = {
            onDrag: this.onDrag,
            onDragStart: this.onDragStart,
            onDragEnd: this.onDragEnd
        };
        const style = this.getStyle();
        return (
            <div style={style.root} ref={(ref) => this.root = ref} data-test-id={this.props.dataTestId}>
                {
                this.state.dragging ?
                <div style={style.hint}>
                    {Math.round(this.props.width)} &times; {Math.round(this.props.height)}
                </div>
                : null
                }

                {
                !smallWidth && controls.indexOf("S") >= 0 ?
                <ResizeHandle isRound={true} pos="S" left="50%" bottom={- d} {...handlers} />
                : null
                }

                {
                controls.indexOf("SE") >= 0 ?
                <ResizeHandle isRound={false} pos="SE" right={- d} bottom={- d} {...handlers} />
                : null
                }

                {
                !smallHeight && controls.indexOf("E") >= 0 ?
                <ResizeHandle isRound={true} pos="E" right={- d} top="50%" {...handlers} />
                : null
                }

                {
                !smallHeight && controls.indexOf("W") >= 0 ?
                <ResizeHandle isRound={true} pos="W" left={- d} top="50%" {...handlers} />
                : null
                }

                {
                controls.indexOf("SW") >= 0 ?
                <ResizeHandle isRound={false} pos="SW" left={- d} bottom={- d} {...handlers} />
                : null
                }
            </div>
        );
    }

    private onDrag = (dx: number, dy: number, pos: string) => {
        this.props.onResize(dx, dy, pos);
    };

    private onDragStart = () => {
        if (this.props.onDragStart) {
            this.props.onDragStart();
        }
        this.setState({dragging: true});
    };

    private onDragEnd = () => {
        if (this.props.onDragEnd) {
            this.props.onDragEnd();
        }
        this.setState({dragging: false});
    };

    private getStyle() {
        const outline = this.props.outline;
        return {
            root: {
                boxSizing: 'border-box',
                border: `${outline}px solid rgba(133, 150, 243, 0.6)`,
                height: Math.floor(this.props.height),
                left: this.props.left,
                pointerEvents: this.props.pointerEventsNone ? 'none' : null,
                position: this.props.position,
                top: this.props.top,
                transition: 'opacity 0.2s ease-out',
                opacity: 0,
                width: Math.floor(this.props.width),
                zIndex: this.props.zIndex
            },
            hint: {
                transform: `translateY(calc(-100% - ${outline}px)) translateX(-${outline}px)`,
                background: 'rgb(33, 150, 243)',
                color: 'white',
                display: 'inline-block',
                padding: '0 5px',
                fontFamily: 'Open Sans',
                fontSize: '14px',
                whiteSpace: 'nowrap'
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/ResizeControls.tsx
 **/